// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
import { Box, Divider, Grid, DragDrop } from "@/components/core";
import { useShortcutMenuStore } from "@/store/shortcut-menu";
import { ShortcutItem } from "./shortcut-item";

const SHORTCUT_POSITION = {
  visible: "visible-shortcuts",
  hidden: "hidden-shortcuts",
};

const reorder = (list: any, startIndex: any, endIndex: any) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const getListStyle = () => ({
  display: "flex",
  justifyContent: "flex-end",
  flexWrap: "wrap",
  flex: "1 1 0px",
});

export function DraggableShortcuts() {
  const { isEditing, shortcuts, setShortcuts } = useShortcutMenuStore();

  const onDragEnd = ({ source, destination }: any) => {
    if (!destination || destination.index === source.index) {
      return;
    }

    if (source.droppableId === SHORTCUT_POSITION.visible) {
      // moved inside visible area, just update order
      if (destination.droppableId === SHORTCUT_POSITION.visible) {
        const newList = reorder(shortcuts, source.index, destination.index);
        setShortcuts(newList);
      }

      // move from visible to hidden
      else if (destination.droppableId === SHORTCUT_POSITION.hidden) {
        const newList = Array.from(shortcuts);
        const newItem = { ...newList[source.index], visible: false };
        newList[source.index] = newItem;
        setShortcuts(newList);
      }
      // Moved from hidden to visible
    } else if (
      source.droppableId === SHORTCUT_POSITION.hidden &&
      destination.droppableId === SHORTCUT_POSITION.visible
    ) {
      let newList = Array.from(shortcuts);
      const newItem = { ...newList[source.index], visible: true };
      newList[source.index] = newItem;
      newList = reorder(newList, source.index, destination.index);
      setShortcuts(newList);
    }
  };

  if (!isEditing) {
    return (
      <Grid spacing={2}>
        {shortcuts.map(
          (shortcut: any, index: any) =>
            shortcut.visible && (
              <Grid.Item key={shortcut.id.toString()}>
                <ShortcutItem shortcut={shortcut} index={index} />
              </Grid.Item>
            )
        )}
      </Grid>
    );
  }

  return (
    <Box>
      <DragDrop onDragEnd={onDragEnd}>
        <DragDrop.Droppable droppableId={SHORTCUT_POSITION.visible} direction="horizontal">
          {(provided: any, snapshot: any) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              style={getListStyle(snapshot.isDraggingOver)}
            >
              {shortcuts.map(
                (shortcut: any, index: any) =>
                  shortcut.visible && (
                    <ShortcutItem key={shortcut.id} shortcut={shortcut} index={index} />
                  )
              )}
              {provided.placeholder}
            </div>
          )}
        </DragDrop.Droppable>
        {isEditing && (
          <>
            <Divider sx={{ my: 3 }} />
            <DragDrop.Droppable droppableId={SHORTCUT_POSITION.hidden} direction="horizontal">
              {(provided: any, snapshot: any) => (
                <div
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  style={getListStyle(snapshot.isDraggingOver)}
                >
                  {shortcuts.map(
                    (shortcut: any, index: any) =>
                      !shortcut.visible && (
                        <ShortcutItem key={shortcut.id} shortcut={shortcut} index={index} />
                      )
                  )}
                  {provided.placeholder}
                </div>
              )}
            </DragDrop.Droppable>
          </>
        )}
      </DragDrop>
    </Box>
  );
}
